import React, { useEffect, useCallback, useState} from 'react';
import SamplePackFlow from './SamplePackFlow.js';
import ReleaseType from './ReleaseType.js';
import DiscogsFlow from './DiscogsFlow.js';

import {connect} from 'react-redux';
import {SAMPLE_PACK, RECORD} from 'constants/release-types.js';

const SaveNewSample = ({track, sample}) => { 
    const [releaseType, setReleaseType] = useState(undefined);

    return (
        <div className="save-new-sample">
          <div className="sample-save-info">
            Match the sample to it's source
          </div>
          <ReleaseType setReleaseType={setReleaseType} releaseType={releaseType}/>
          {releaseType === RECORD ? <DiscogsFlow sample={sample}/> : ""}
          {releaseType === SAMPLE_PACK ? <SamplePackFlow track={track} sample={sample}/> : ""}
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SaveNewSample);
